module.exports = __webpack_public_path__ + "img/factory01.63f4c28f.jpg";